<template>
  <div>
    <Header :useruid="this.$route.params.useruid" :title="$t('category.manage_category')" :showDate="false"></Header>
    <div class="rel-grid-container">
      <div id="top-div"></div>
      <form v-on:submit.prevent="updateCategory" id="form-fix">
        <span class="form-box-title">{{$t('category.desired_category')}}</span>
        <div class="form-box">
          <span class="form-box-name">{{$t('category.name_text')}}</span><b-form-input v-model="category.name" type="text" pattern="[^<>]*" :title="$t('global.pattern_title')" style="max-width: 300px;" class="form-box-input" required></b-form-input>
          <b-form-checkbox style="grid-column: 2;" v-model="category.disabled" value="1" unchecked-value="0">
                  {{$t('member.disabled_text')}}
                </b-form-checkbox>
        </div>
        <b-alert variant="danger" class="fit-width" dismissible :show="showAlert" style="margin: 10px auto;" @dismissed="showAlert=false">
            {{alertText}}
          </b-alert>
        <div class="submit-box-2">
          <b-button v-b-modal.modal-center v-if="category.id>0" class="submit-button4" variant="clear-blue"><div class="delete-button"></div><span>{{$t('global.button_delete')}}</span></b-button>
          <b-button class="submit-button4" v-on:click="back" variant="clear-blue"><div class="cancel-button"></div><span>{{$t('global.button_cancel')}}</span></b-button>
          <b-button class="submit-button4" type="submit" variant="clear-blue"><div class="save-button"></div><span>{{$t('global.button_save')}}</span></b-button>
        </div>
        <b-modal id="modal-center" v-model="showDelete" centered :title="$t('category.delete_title')">
          <p class="my-4">{{$t('category.delete_text')}}</p>
          <div slot="modal-footer" class="submit-box-2">
            <b-button class="submit-button4" v-on:click="showDelete=false" variant="clear-blue"><div class="cancel-button"></div><span>{{$t('global.button_cancel')}}</span></b-button>
            <b-button class="submit-button4" v-on:click="deleteCategory" variant="clear-blue"><div class="delete-button"></div><span>{{$t('global.button_delete')}}</span></b-button>
          </div>
        </b-modal>
      </form>
      <div class="div-space"></div>
    </div>
    <Footer :useruid="this.$route.params.useruid"></Footer>
  </div>
</template>
<style scoped>
  
</style>
<script>
    
  import router from "../router"
    export default {
    name: "Category",
   
      data() {
        return {
          showDelete: false,
          saveVariant: "blue",
          category: {id:0,name: "",disabled:0},
          useruid: '',
          showAlert: false,
          alertText: ''
        }
      },
        methods: {
          getCategory() {
            this.category.id = this.$route.params.id;
            if (this.category.id > 0) {
              this.category.useruid = this.useruid;
              this.$http.post("/api/organization/category/get"+(this.useruid==''? "" : "/byuseruid"), this.category).then((response) => {
                if (response.data.success) {
                  this.category = response.data.category;
                }
              }).catch(() => {});
            } 
          },
          updateCategory() {
            this.showAlert = false;
            this.category.useruid = this.useruid;
            this.$http.post("/api/organization/category/update"+(this.useruid==''? "" : "/byuseruid"), this.category).then((response) => {
              if(response.data.errorcode == 2){
                this.showAlert = true;
                this.alertText = this.$t('category.duplicate_name');
              }
              if (response.data.success === true) {
                this.saveVariant = 'success';
                this.back();
              } else {
                this.saveVariant = 'danger';
              }
            }).catch(() => {this.$bvToast.show('serverError');});
          },
          deleteCategory() {
            this.category.useruid = this.useruid;
            this.$http.post("/api/organization/category/delete"+(this.useruid==''? "" : "/byuseruid"), this.category).then((response) => {
              if (response.data.success === true) {
                this.back();
              }
            }).catch(() => {});
          },
          back(){
             if (this.permissions.access) {
                router.push("/admin/categories");
              }else if(this.useruid.length>0){
                router.push("/categories/"+this.useruid);
              }
          }
    },
    destroyed() {
      this.removeClass(document.getElementById("menu-categories"), "active-menu");
      this.removeClass(document.getElementById("menu-chapter"), "active-menu");
    },
    mounted() {
      if(this.$route.params.useruid){
        this.useruid = this.$route.params.useruid;
      }
      this.addClass(document.getElementById("menu-categories"), "active-menu");
      this.addClass(document.getElementById("menu-chapter"), "active-menu");
      this.getCategory();
    }
    }
</script>
